// Short project hint shown on tabs and under the Projects icon: the NB number, or the ship name for projects without one
export const projectHint = (p) => {
  if (!p) return '';
  if (p.newbuildingNo) return `#${String(p.newbuildingNo).padStart(3, '0')}`;
  return p.shipName || '';
};
